/** The problem+json fields the screens use (docs/05-api-contracts.md section 2). */
export interface Problem {
  readonly code?: string;
  readonly detail?: string;
  readonly errors?: readonly { path: string; message: string }[];
}

const KNOWN = new Set([
  "INVALID_CODE",
  "RATE_LIMITED",
  "VALIDATION_FAILED",
  "DUPLICATE_REGISTRATION",
  "PERMISSION_DENIED",
  "INVALID_TRANSITION",
  "PROVIDER_UNAVAILABLE",
  "NOT_FOUND",
  "AUTH_REQUIRED",
  "ENTERPRISE_NOT_VERIFIED",
  "ENTERPRISE_SUSPENDED",
  "AGREEMENT_ACCEPTANCE_REQUIRED",
  "FILE_TOO_LARGE",
  "FILE_TYPE_NOT_ALLOWED",
  "CONTACT_REQUIRED",
  "KYB_NOT_ACTIVE",
  "PRODUCT_UNAVAILABLE",
  "BELOW_MOQ",
  "QUOTE_EXPIRED",
  "QUOTE_SUPERSEDED",
  "SHOP_NOT_SELLING",
  "COUNTRY_NOT_SERVED",
  "MARKET_NOT_OPEN",
  "VERSION_CONFLICT",
  "CURRENCY_NOT_ENABLED",
  "PAYMENT_METHOD_DISABLED",
  "FX_UNAVAILABLE",
  "STEP_UP_REQUIRED",
  "FILE_NOT_CLEAN",
  "CASE_OPEN",
  "EXCEEDS_OPEN_QUANTITY",
  "LAST_ADMIN",
  "INVOICE_SETTINGS_REQUIRED",
]);

/** The resource key for an API error; unknown codes get the generic message. */
export function errorKey(problem: unknown): string {
  const code = (problem as Problem | undefined)?.code;
  return code !== undefined && KNOWN.has(code) ? `errors.${code}` : "errors.generic";
}

/** Field errors keyed by path, such as `body.address.fields.postalCode`. */
export function fieldErrors(problem: unknown): Record<string, string> {
  const errors = (problem as Problem | undefined)?.errors ?? [];
  return Object.fromEntries(errors.map((error) => [error.path, error.message]));
}
